import { Link } from "react-router-dom";
import TriAxisLogo from "../TriAxisLogo";

/** Brand mark + dual-line wordmark used in the navbar (and re-usable elsewhere). */
export default function NavbarBrand() {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
      <TriAxisLogo size={36} testid="navbar-logo-icon" className="shrink-0" />
      <div
        className="leading-none"
        style={{ display: "grid", gridTemplateColumns: "auto" }}
      >
        <div className="display text-[21px] font-extrabold tracking-tight text-slate-900 whitespace-nowrap">
          Tri-Axis <span className="text-emerald-700">XYZ</span>
        </div>
        <div
          className="mono text-[10px] uppercase text-slate-500 mt-0.5"
          style={{ textAlign: "justify", textAlignLast: "justify" }}
        >
          Survey CAD Solutions
        </div>
      </div>
    </Link>
  );
}
